import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useStandaloneBack } from "@/hooks/useStandaloneBack";
import { cn } from "@/lib/utils";

// NAV-5: der Zurueck-Pfeil links vom Logo — nur in der installierten App
// (siehe `useStandaloneBack`). Die Brotkrumen bleiben: sie beantworten «wo
// bin ich», der Pfeil «woher kam ich». Zwei Fragen, zwei Traeger.
//
// `navigate(-1)` ist react-routers Weg fuer `history.back()` — im Browser
// dasselbe, in Tests (MemoryRouter) beobachtbar.
export function StandaloneBackButton({
  className,
}: {
  readonly className?: string;
}) {
  const state = useStandaloneBack();
  const navigate = useNavigate();
  if (state === "hidden") return null;
  const disabled = state === "disabled";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          disabled={disabled}
          aria-label="Zurück"
          data-testid="topnav-back"
          onClick={() => {
            void navigate(-1);
          }}
          className={cn(
            "shrink-0 text-muted-foreground hover:text-foreground",
            className,
          )}
        >
          <ArrowLeft className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Zurück</TooltipContent>
    </Tooltip>
  );
}
